// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSHeader/ABSInternalMessage/index.less
// module id = 742
// module chunks = 42